import { Bell } from "lucide-react";

const FONT = "Outfit, 'Plus Jakarta Sans', sans-serif";

const DocCard = ({ cls, x, fill, tag, tagColor, title, sub }) => (
  <g className={cls}>
    <rect x={x} y="118" width="150" height="98" rx="14" fill={fill} />
    <rect x={x} y="118" width="150" height="98" rx="14" fill="none" stroke="#102B40" strokeOpacity=".06" />
    <rect x={x + 14} y="132" width={tag.length * 7 + 14} height="18" rx="9" fill={tagColor} />
    <text x={x + 21} y="144.5" fontFamily={FONT} fontSize="9" fontWeight="700" letterSpacing="1.2" fill="#fff">{tag}</text>
    <text x={x + 14} y="170" fontFamily={FONT} fontSize="12.5" fontWeight="600" fill="#102B40">{title}</text>
    <text x={x + 14} y="186" fontFamily={FONT} fontSize="9.5" fill="#65798A">{sub}</text>
  </g>
);

const SPARKS = [[150, 0], [205, 0.4], [258, 0.8], [292, 0.25]];

function WalletSvg() {
  return (
    <svg viewBox="0 0 440 400" className="relative z-10 h-full w-full" role="img" aria-label="An emerald warranty wallet opening to reveal an invoice, a warranty card and a guarantee card, sealed by a protection shield">
      <defs>
        <linearGradient id="wBack" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stopColor="#0A6B58" /><stop offset="1" stopColor="#033A31" /></linearGradient>
        <linearGradient id="wFront" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stopColor="#19CFA2" /><stop offset=".55" stopColor="#08977A" /><stop offset="1" stopColor="#055A4B" /></linearGradient>
        <linearGradient id="wFlap" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stopColor="#0C7D66" /><stop offset="1" stopColor="#11B48D" /></linearGradient>
        <linearGradient id="wMetal" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stopColor="#FFFFFF" /><stop offset=".5" stopColor="#BDF4E8" /><stop offset="1" stopColor="#4FD4D6" /></linearGradient>
        <linearGradient id="wSheen" x1="0" y1="0" x2="1" y2="0"><stop offset="0" stopColor="#fff" stopOpacity="0" /><stop offset=".5" stopColor="#fff" stopOpacity=".3" /><stop offset="1" stopColor="#fff" stopOpacity="0" /></linearGradient>
        <clipPath id="wPocketClip"><rect x="60" y="226" width="320" height="130" rx="34" /></clipPath>
        <filter id="wShadow" x="-30%" y="-30%" width="160%" height="170%"><feDropShadow dx="0" dy="24" stdDeviation="20" floodColor="#0B3B33" floodOpacity=".3" /></filter>
        <filter id="wGlow" x="-50%" y="-50%" width="200%" height="200%"><feGaussianBlur stdDeviation="6" /></filter>
      </defs>

      <ellipse cx="220" cy="372" rx="150" ry="13" fill="#102B40" opacity=".12" className="ww-shadow-breathe" />

      {SPARKS.map(([x, d], i) => (
        <circle key={i} cx={x} cy="200" r="3.5" fill="#3CCFD2" className="ww-spark" style={{ animationDelay: `${d}s` }} />
      ))}

      <g filter="url(#wShadow)">
        <rect x="60" y="150" width="320" height="206" rx="34" fill="url(#wBack)" />
        <DocCard cls="ww-doc-b" x={145} fill="#FFFFFF" tag="WARRANTY" tagColor="#087C65" title="Warranty Card" sub="Samsung Refrigerator" />
        <DocCard cls="ww-doc-a" x={74} fill="#FFFFFF" tag="INVOICE" tagColor="#65798A" title="Purchase Invoice" sub="Receipt safely stored" />
        <DocCard cls="ww-doc-c" x={216} fill="#EAF9F9" tag="GUARANTEE" tagColor="#2FB5B8" title="Guarantee" sub="Coverage safely stored" />

        <rect x="60" y="226" width="320" height="130" rx="34" fill="url(#wFront)" />
        <g clipPath="url(#wPocketClip)"><rect x="-140" y="220" width="110" height="140" fill="url(#wSheen)" className="ww-sheen-2" /></g>
        <path d="M94 227h252" stroke="#C9FFF3" strokeOpacity=".7" strokeWidth="1.6" strokeLinecap="round" />
        <rect x="74" y="240" width="292" height="102" rx="26" fill="none" stroke="#C9FFF3" strokeOpacity=".22" strokeDasharray="5 6" />
        <text x="92" y="330" fontFamily={FONT} fontSize="10" fontWeight="600" letterSpacing="3" fill="#EAF9F9" opacity=".75">WARRANTY WALLET</text>

        <circle cx="220" cy="282" r="44" fill="#7FE8D3" opacity=".35" filter="url(#wGlow)" className="ww-shield-glow" />
        <circle cx="220" cy="282" r="32" fill="url(#wMetal)" />
        <circle cx="220" cy="282" r="25" fill="#087C65" />
        <path d="M220 266l13 5v9.5c0 8-5.5 13.6-13 16-7.5-2.4-13-8-13-16V271l13-5Z" fill="#EAF9F9" />
        <path d="M214 282l4.5 4.5 8-8.5" fill="none" stroke="#087C65" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" strokeDasharray="20" className="ww-check" />

        <g className="ww-flap">
          <path d="M300 150h56a24 24 0 0 1 24 24v58a20 20 0 0 1-20 20h-40a20 20 0 0 1-20-20Z" fill="url(#wFlap)" />
          <path d="M300 150h56a24 24 0 0 1 24 24v58a20 20 0 0 1-20 20h-40a20 20 0 0 1-20-20Z" fill="none" stroke="#C9FFF3" strokeOpacity=".35" />
          <circle cx="340" cy="228" r="9" fill="url(#wMetal)" />
          <circle cx="340" cy="228" r="4" fill="#087C65" />
        </g>
      </g>
    </svg>
  );
}

export const WalletArt = ({ compact = false }) => (
  <div className="relative mx-auto aspect-square w-full max-w-[560px]" data-testid="wallet-illustration">
    <div className="ww-breathe absolute inset-[14%] rounded-full bg-[radial-gradient(circle,rgba(8,168,129,0.32),rgba(60,207,210,0.12)_55%,transparent_72%)] blur-2xl" />
    <div className="absolute inset-[2%]"><WalletSvg /></div>
    <div
      data-testid="wallet-chip-reminder"
      className={`ww-toast absolute z-20 flex items-center gap-3 rounded-2xl border border-white/80 bg-white/90 py-2.5 pl-2.5 pr-4 shadow-[0_18px_44px_-18px_rgba(16,43,64,0.45)] backdrop-blur-xl ${compact ? "bottom-[4%] left-[4%] scale-90" : "right-[2%] top-[10%] max-sm:right-0 max-sm:top-[4%] max-sm:scale-90"}`}
    >
      <span className="ww-ring flex h-9 w-9 items-center justify-center rounded-xl bg-ww-emerald text-white"><Bell className="h-4 w-4" /></span>
      <span className="leading-tight">
        <span className="block text-[10px] font-semibold uppercase tracking-[0.14em] text-ww-emerald">Expiry Reminder</span>
        <span className="block whitespace-nowrap text-[13px] font-semibold text-ww-navy">Expires in 30 days</span>
      </span>
    </div>
  </div>
);
